// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-3mwvZ","inner":"inner-w30YQ"};